import { IdEnums, ShortCodeEnums } from '@nhl/nhl-breakaway-ui';

import { ApiResponseNHL, useFetchLeagueData } from '~/core/api';

import { ClubStats, SeasonInfo } from './types';

export const useClubStatsForSeasonQuery = (
    club: ShortCodeEnums.TeamTriCode,
    season: string | undefined,
    gameType: IdEnums.GameType
): ApiResponseNHL<ClubStats> => useFetchLeagueData(`/club-stats/${club}/${!season ? 'now' : season + '/' + gameType}`);

export const useClubSeasonsHistoryQuery = (club: ShortCodeEnums.TeamTriCode): ApiResponseNHL<Array<SeasonInfo>> =>
    useFetchLeagueData(`/club-stats-season/${club}`);
